// extracted by mini-css-extract-plugin
export var root = "generic-page-subhead-module--root--ul7-t";